export const EXPORT_FORMATS = Object.freeze({
  CSV: 'CSV',
  XLSX: 'XLSX'
})

export const EXPORT_FORMAT_OPTIONS = Object.freeze([
  { key: EXPORT_FORMATS.CSV, name: 'CSV (.csv)' },
  { key: EXPORT_FORMATS.XLSX, name: 'Excel (.xlsx)' }
])

export const EXPORT_FORMAT_EXTENSIONS = Object.freeze({
  [EXPORT_FORMATS.CSV]: 'csv',
  [EXPORT_FORMATS.XLSX]: 'xlsx'
})
